module.exports = __webpack_public_path__ + "img/mrtx.c4a6b078.png";